
import { ProcessForgotPasswordComponent } from "../../components/authentication/processForgotPassword";
import AuthPage from "../../components/layout/authPage"

import { OTPForm } from "../../components/otpForm";


export const ProcessForgotPage = () => {
    return (
        <AuthPage>
          <ProcessForgotPasswordComponent/>
        </AuthPage>
    )
}